/** Formatting for a dense table: short, fixed, and the same everywhere. */

export const NA = '—';

export function price(value: number | undefined, digits = 2): string {
  return value === undefined ? NA : value.toFixed(digits);
}

/** A fraction as a percentage: 0.0523 → "5.23%". */
export function pct(value: number | undefined, digits = 1): string {
  return value === undefined ? NA : `${(value * 100).toFixed(digits)}%`;
}

/** A signed dollar figure: -12.3 → "−$12.30". */
export function dollars(value: number | undefined, digits = 2): string {
  if (value === undefined) {
    return NA;
  }
  const sign = value < 0 ? '−' : '';
  return `${sign}$${Math.abs(value).toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
}

export function days(value: number | undefined): string {
  return value === undefined ? NA : `${value.toFixed(1)}d`;
}

/** An epoch timestamp as Eastern `HH:mm`, the zone every session time on this page is in. */
export function easternTime(timestamp: number): string {
  return new Date(timestamp).toLocaleTimeString('en-US', { timeZone: 'America/New_York', hour: '2-digit', minute: '2-digit', hour12: false });
}

/** An epoch timestamp as its Eastern calendar date, `YYYY-MM-DD`. */
export function easternDate(timestamp: number): string {
  return new Date(timestamp).toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
}

/** A strike without trailing zeros: 320 → "320", 97.5 → "97.5". */
export function strike(value: number): string {
  return Number.isInteger(value) ? String(value) : String(Number(value.toFixed(3)));
}
